import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "./shared/AuthContext";

const Logout = () => {

  const navigate = useNavigate();
  const { logout } = useContext(AuthContext);

  const handleLogout = () => {
  
    logout();

    // Redirect to login page
    navigate("/");
  };

  return <span onClick={handleLogout}>Logout</span>;
};

export default Logout;
